<template>
	<div v-editable="blok" class="mb-6 md:mb-10">
		<div class="mb-6 md:mb-8 offset-sub-content">
			<h3 class="typo-h4 text-heading-primary mb-2 md:mb-4">
				{{ blok.title }}
			</h3>
			<RichText class="font-primary typo-body-m text-body-primary" :data="blok.perex" />
		</div>

		<div class="md:grid sm:grid-cols-2 lg:grid-cols-3 md:gap-8">
			<StoryblokComponent
				v-for="item, index in blok.children"
				:key="item._uid"
				:blok="item"
				:count="index"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {OrderedParagraphsListStoryblok} from '@/storyblok/types';

	interface Props {
		blok: OrderedParagraphsListStoryblok
	}
	defineProps<Props>();
</script>
